// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  buildId: __t.u64().primaryKey().name("build_id"),
  projectId: __t.u64().name("project_id"),
  jobId: __t.u64().name("job_id"),
  bytecode: __t.string(),
  bytecodeHash: __t.string().name("bytecode_hash"),
  sig: __t.string(),
  signed: __t.bool(),
  verified: __t.bool(),
  verifiedAt: __t.timestamp().name("verified_at"),
  createdAt: __t.timestamp().name("created_at"),
  publishedAt: __t.timestamp().name("published_at"),
});
